<script>
    import { Doughnut, mixins } from 'vue-chartjs';
    const { reactiveProp } = mixins;
    import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

    import Chart from 'chart.js';
    Chart.plugins.unregister(ChartJsPluginDataLabels); 

    //cref:https://github.com/chartjs/chartjs-plugin-datalabels/issues/10

    export default {
        name: "DonutChart",
        extends: Doughnut,
        mixins: [reactiveProp],
        props: ['options'],
        mounted() {
            this.addPlugin(ChartJsPluginDataLabels); //https://github.com/chartjs/chartjs-plugin-datalabels/issues/188
            this.renderChart(this.chartData, this.options);
        },
        components: {
            ChartJsPluginDataLabels
        }
    }
</script>